import type { AssetPositionAssetLinkOut } from "kubb";
import AssetPositionAssetRowContainer from "./AssetPositionAssetRowContainer";
import AssetPositionAssetRowInner, {
  type AssetPositionAssetRowInnerProps,
} from "./AssetPositionAssetRowInner";

function AssetPositionAssetRow(props: {
  value: AssetPositionAssetLinkOut;
  view: "asset" | "assetPosition";
  refreshList?: () => Promise<any> | undefined;
}) {
  return (
    <AssetPositionAssetRowContainer
      link={props.value}
      refreshList={props.refreshList}
    >
      {(innerProps: AssetPositionAssetRowInnerProps) => {
        return <AssetPositionAssetRowInner view={props.view} {...innerProps} />;
      }}
    </AssetPositionAssetRowContainer>
  );
}

export default AssetPositionAssetRow;
